"use client";

import Image from "next/image";
import { ShoppingCart, Star, ArrowRight } from "lucide-react";
import { Product } from "./products";

interface Props {
    product: Product;
}

export const ProductCard = ({ product }: Props) => {
    return (
        <div className="group bg-card rounded-xl overflow-hidden  transition-all duration-300 border border-border">
            <div className="flex h-full">
                {/* Image Side */}
                <div className="w-2/5 relative bg-secondary flex items-center justify-center p-2">
                    <div className="relative w-full aspect-square overflow-hidden rounded-lg group-hover:scale-105 transition-transform duration-300">
                        <Image
                            src={product.image}
                            alt={product.title}
                            fill
                            className="object-cover"
                        />
                    </div>
                </div>

                {/* Content Side */}
                <div className="w-3/5 p-3 flex flex-col">
                    {/* Tag & Rating */}
                    <div className="flex justify-between mb-2">
                        <div className="bg-primary/20 text-[#9c9c9c] text-xs px-2 pt-1 rounded-full flex items-center justify-center">
                            {product.tag}
                        </div>
                        <div className="flex items-center gap-1">
                            <span className="text-xs text-muted-foreground mt-1.5">{product.rating}</span>
                            <Star size={14} className="fill-yellow-400 text-yellow-400" />
                        </div>
                    </div>

                    {/* Title */}
                    <h3 className="text-sm font-semibold text-card-foreground mb-1 line-clamp-2 min-h-[2.5rem]">
                        {product.title}
                    </h3>

                    {/* Category */}
                    <p className="text-xs text-muted-foreground mb-auto">
                        {product.category}
                    </p>

                    {/* Price & Action */}
                    <div className="mt-3 flex items-center justify-between">
                        <div className="space-y-0.5">
                            <div className="flex items-center gap-1">
                                <span className="text-card-foreground font-bold">{product.price}</span>
                                <span className="text-xs text-muted-foreground">تومان</span>
                            </div>
                            {product.oldPrice && (
                                <div className="text-xs text-muted-foreground/70 line-through">{product.oldPrice}</div>
                            )}
                        </div>

                        <div className="flex gap-2">
                            <button className="w-7 h-7 rounded-lg bg-primary text-primary-foreground hover:bg-primary-dark flex items-center justify-center transition-colors">
                                <ShoppingCart size={14} />
                            </button>
                            <button className="w-7 h-7 rounded-lg bg-secondary text-secondary-foreground hover:bg-secondary/80 flex items-center justify-center transition-colors">
                                <ArrowRight size={14} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
